import { useState } from "react";
import { Box, Button, Text, Title } from "@mantine/core";
import { observer } from "mobx-react";
import { EpisodeRow } from "@/components/episode/EpisodeRow";
import styles from "@/components/episode/styles/EpisodeRow.module.css";
import { useStores } from "@/hooks/useStores";

const SHELF_SIZE = 5;

/** New episodes from the podcasts the listener follows, minus the ones they have already played */
export const NewFromFollowed = observer(() => {
    const { feedStore, listeningStore } = useStores();
    const [shown, setShown] = useState(SHELF_SIZE);

    const unplayed = feedStore.entries.filter((entry) => !listeningStore.isPlayed(entry.id));
    if (!feedStore.loaded || unplayed.length === 0) {
        return null;
    }

    const more = () => {
        const next = shown + SHELF_SIZE;
        setShown(next);
        // The page in memory may not reach as far as what is asked for
        if (next > unplayed.length && feedStore.nextCursor !== "") void feedStore.loadMore();
    };

    return (
        <Box component="section" aria-labelledby="new-from-followed" mb="xl">
            <Title className={styles.heading} id="new-from-followed" mb="xs" order={2}>
                Nytt från det du följer
            </Title>
            {feedStore.total > 0 && (
                <Text c="dimmed" mb="sm" size="sm">
                    {feedStore.total === 1 ? "1 nytt avsnitt" : `${feedStore.total} nya avsnitt`} de senaste 30 dagarna
                </Text>
            )}
            <ul className={styles.list}>
                {unplayed.slice(0, shown).map((entry) => (
                    <EpisodeRow
                        episode={entry as unknown as Episode}
                        key={entry.id}
                        podcast={entry.podcast as unknown as Podcast}
                        showPodcast
                        withMenu
                    />
                ))}
            </ul>
            {(unplayed.length > shown || feedStore.nextCursor !== "") && (
                <Button
                    color="gray"
                    loading={feedStore.loadingMore}
                    mt="sm"
                    onClick={more}
                    radius="md"
                    size="sm"
                    variant="default">
                    Visa fler
                </Button>
            )}
        </Box>
    );
});
